module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Acknowledgments")])]), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Introduction: Confessions")])]), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("Part I")])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("1")]), _vm._v(" Being at Altitude"), _c('br'), _c('i', [_vm._v("Understanding the Digital Ecology")])])]), _c('div', {
    staticClass: "SOM_chap_2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FREEDOM PROJECT: Experiments in Praxis"), _c('br'), _c('i', [_vm._v("An Overview")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("2")]), _vm._v(" The Terms of Agreement"), _c('br'), _c('i', [_vm._v("What Digital Media Companies Have Known All Along")])])]), _c('div', {
    staticClass: "SOM_chap_2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FREEDOM PROJECT: Experiments in Praxis"), _c('br'), _c('i', [_vm._v("Stage One: Digital Media Fast")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("3")]), _vm._v(" The Industrialization of You and Me"), _c('br'), _c('i', [_vm._v("How Social Media Makes Relationships a Business")])])]), _c('div', {
    staticClass: "SOM_chap_2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FREEDOM PROJECT: Experiments in Praxis"), _c('br'), _c('i', [_vm._v("Stage Two: Digital Stocktaking")])])]), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("4")]), _vm._v(" The Good News")])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("5")]), _vm._v(" Created for Communion, Settling for Connection"), _c('br'), _c('i', [_vm._v("A Theological Anthropology")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("6")]), _vm._v(" Digital Practices as (Secular) Liturgy")])]), _c('div', {
    staticClass: "SOM_chap_2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FREEDOM PROJECT: Experiments in Praxis"), _c('br'), _c('i', [_vm._v("Stage Three: Secular Liturgy and Counterliturgy")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("7")]), _vm._v(" Reimagining Time and Attention"), _c('br'), _c('i', [_vm._v("Soul Formation in a Culture of Productivity")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("8")]), _vm._v(" Embodied and Embedded"), _c('br'), _c('i', [_vm._v("Transforming Sites of Faithful Presence and Sacred Spaces")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev5"
  }, [_vm._v("9")]), _vm._v(" The Church as Counterliturgy"), _c('br'), _c('i', [_vm._v("Alternative Futures of Faith Communities")])])]), _c('div', {
    staticClass: "SOM_chap_2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FREEDOM PROJECT: Experiments in Praxis"), _c('br'), _c('i', [_vm._v("Stage Four: Alternative Futures")])])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Restless Devices")])])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0